var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElectrical = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  viewBox: "0 0 21 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.2 18.7v-8.4h1.7v10.1H4.5v-9.2h1.6v7.5zM14.5 1.9V.3h5v1.6z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.9 4.5v3.3c0 1.9 1.5 3.4 3.4 3.4 1.8 0 3.3-1.5 3.3-3.4V4.5zm3.4 8.3c-2.8 0-5-2.2-5-5v-5h10v5c0 2.8-2.2 5-5 5M15.3 4.5v5.8h3.4V4.5zm5.1-1.7V12h-6.7V2.8z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.6 4.5H1.9V.3h1.7zM8.6 4.5H7V.3h1.6z"
})));
export default SvgElectrical;